import React, { useState, useEffect } from 'react';
import Navbar from '../Shared/Navbar';
import api from '../../config/api';
import './CurationConsole.css';

function CurationConsole({ user, onLogout }) {
  const [queue, setQueue] = useState([]);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchQueue();
  }, []);

  const fetchQueue = async () => {
    try {
      const response = await api.get('/api/ai/curation-queue');
      setQueue(response.data.queue);
    } catch (error) {
      console.error('Failed to fetch queue:', error);
    } finally {
      setLoading(false);
    }
  };

  const getConfidenceColor = (confidence) => {
    if (confidence >= 0.90) return 'success';
    if (confidence >= 0.70) return 'warning';
    return 'error';
  };

  const getConfidenceLabel = (confidence) => {
    if (confidence >= 0.90) return 'High';
    if (confidence >= 0.70) return 'Medium';
    return 'Low';
  };

  const handleConfirm = async (tag) => {
    try {
      await api.post('/api/ai/tags/update', {
        assetId: selectedAsset.id,
        tags: { ...selectedAsset.aiTags, [tag]: { ...selectedAsset.aiTags[tag], confirmed: true } }
      });
      
      alert('Tag confirmed! This helps improve our AI.');
    } catch (error) {
      console.error('Failed to confirm tag:', error);
    }
  };

  if (loading) {
    return (
      <div>
        <Navbar user={user} onLogout={onLogout} userType="creator" />
        <div className="curation-container">
          <div className="loading">Loading curation queue...</div>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Navbar user={user} onLogout={onLogout} userType="creator" />
      
      <div className="curation-container">
        <div className="curation-header">
          <div>
            <h1>AI Tagging & Curation</h1>
            <p className="text-gray-600">Review and refine AI-generated tags for your assets</p>
          </div>
          <div className="badge badge-info">
            {queue.length} items to review
          </div>
        </div>

        <div className="curation-layout">
          {/* Asset Grid */}
          <div className="asset-grid">
            {queue.map(asset => (
              <div
                key={asset.id}
                className={`asset-card ${selectedAsset?.id === asset.id ? 'selected' : ''}`}
                onClick={() => setSelectedAsset(asset)}
              >
                <div className="asset-thumbnail">
                  <img src={asset.thumbnail} alt={asset.filename} />
                </div>
                <div className="asset-info">
                  <div className="asset-filename">{asset.filename}</div>
                  {asset.needsReview && (
                    <div className="badge badge-warning">Needs Review</div>
                  )}
                </div>
              </div>
            ))}
          </div>

          {/* Tag Detail Panel */}
          {selectedAsset && (
            <div className="tag-panel card">
              <h3>AI-Generated Tags</h3>
              <div className="tag-list">
                {Object.entries(selectedAsset.aiTags).map(([key, tag]) => (
                  <div key={key} className="tag-item">
                    <div className="tag-header">
                      <span className="tag-key">{key.charAt(0).toUpperCase() + key.slice(1)}</span>
                      <span className={`badge badge-${getConfidenceColor(tag.confidence)}`}>
                        {getConfidenceLabel(tag.confidence)} ({(tag.confidence * 100).toFixed(0)}%)
                      </span>
                    </div>
                    <div className="tag-value">
                      <input
                        type="text"
                        className="input"
                        defaultValue={tag.value}
                        placeholder={`Enter ${key}...`}
                      />
                    </div>
                    <div className="tag-actions">
                      <button
                        className="btn btn-sm btn-success"
                        onClick={() => handleConfirm(key)}
                      >
                        ✓ Confirm
                      </button>
                      <button className="btn btn-sm btn-secondary">
                        ✏️ Edit
                      </button>
                    </div>
                  </div>
                ))}
              </div>

              <div className="panel-actions">
                <button className="btn btn-secondary btn-block">
                  Skip for Now
                </button>
                <button className="btn btn-primary btn-block">
                  Save All Changes
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CurationConsole;
